const DotFill = ({fill, width = 4}: {fill: string; width?: number}) => (
  <svg width={width} height={width} viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="">
    <path
      d="M2.00001 0.214279C2.47361 0.214279 2.92781 0.402416 3.2627 0.737303C3.59759 1.07219 3.78572 1.52639 3.78572 1.99999C3.78572 2.47359 3.59759 2.9278 3.2627 3.26268C2.92781 3.59757 2.47361 3.78571 2.00001 3.78571C1.52641 3.78571 1.0722 3.59757 0.737318 3.26268C0.402432 2.9278 0.214294 2.47359 0.214294 1.99999C0.214294 1.52639 0.402432 1.07219 0.737318 0.737303C1.0722 0.402416 1.52641 0.214279 2.00001 0.214279Z"
      fill={fill}
    />
  </svg>
)
export default DotFill
